<template>
  <div class="us_state_card" v-if="visible">
    <div v-if="devInfo.offLine">
      <div style="background:#FDEDED;">
        <div style="text-align:center;">
          <span style="position:relative;"><i class="fa fa-exclamation-circle" style="color:#F56C6C;font-size:1.5rem;position:absolute;top:-0.2rem;" /></span>
          <span style="font-size:0.9rem;margin-left:1.9rem;">主机与服务器断开连接</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="background:#F56C6C;" v-if="devInfo.CUR_SID === 1 || devInfo.CUR_SID === '1'">
        <div style="color:#fff;text-align:center;">
          <i class="fa fa-exclamation-circle" style="margin-right:0.5rem;font-size:1.2rem;" />
          <span style="font-size:0.9rem;">设备异常</span>
        </div>
      </div>
      <div style="background:#BDBDBD;" v-if="devInfo.CUR_SID === 0 || devInfo.CUR_SID === '0'">
        <div style="color:#fff;text-align:center;">
          <i class="fa fa-exclamation-circle" style="margin-right:0.5rem;font-size:1.2rem;" />
          <span style="font-size:0.9rem;">设备未激活</span>
        </div>
      </div>
    </div>
    <!-- <div style="background:#67C23A;height:5rem;line-height:5rem;" v-if="devInfo.CUR_SID === 2 || devInfo.CUR_SID === '2'">
      <div style="color:#fff;text-align:center;">
        <i class="fa fa-check-circle" style="margin-right:0.5rem;font-size:1.2rem;" />
        <span style="font-size:0.9rem;">设备正常</span>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'DeviceStateCard',
  components: {},
  props: {
    devInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  watch: {
  },
  computed: {
    visible() {
      var that = this
      return that.devInfo.CUR_SID === 1 || that.devInfo.CUR_SID === '1' ||
             that.devInfo.CUR_SID === 0 || that.devInfo.CUR_SID === '0' ||
             that.devInfo.offLine
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {}
}
</script>

<style scoped>
.us_state_card{
  /* height: 7rem;
  line-height: 7rem; */
  height: 3.5rem;
  line-height: 3.5rem;
  margin-bottom: 0.3rem;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}
</style>
